<section class="ref-view">
    <ng-template #content>
        <div id="modal" class="ref-app">
            <div class="modal-header font-weight-bold">
                <h4 *ngIf="modalType === 'FOLLOW_UP'">
                    <i class="fas fa-flag-checkered cursor-pointer mr-2"></i>
                    <span>Follow Up - {{ followUpTarget?.reference }}</span>
                </h4>
                <h4 *ngIf="modalType === 'VIEW_FOLLOW_UP_REMARKS'">
                    <i class="fas fa-flag-checkered cursor-pointer mr-2"></i>
                    <span>Follow Up Remarks</span>
                </h4>
                <i class="fas fa-times-circle pull-right text-danger cross-icon cursor-pointer"
                   (click)="this.modalService.dismissAll('')"></i>
            </div>
            <div class="modal-body">
                <div class="row justify-content-center" *ngIf="modalType === 'FOLLOW_UP'">
                    <form class="col-xl-6 col-lg-8 col-md-10 col-sm-12 form mt-2 shadow-none" novalidate [formGroup]="followUpForm">
                        <div class="form-group">
                            <label for="subject">Subjects</label>
                            <input class="form-control" type="text" id="subject" formControlName="subject" placeholder="Enter Subjects"/>
                            <small *ngIf="submitted && followUpForm.get('subject').hasError('required')" class="text-danger">
                                Field is required.
                            </small>
                        </div>

                        <div class="form-group">
                            <label for="stage_id">Stage</label>
                            <select class="form-control" id="stage_id" formControlName="stage_id" (change)="getReasonsFollowups()">
                                <option value="">Select Stage</option>
                                <option [value]="stage?.id" *ngFor="let stage of allStages">{{ stage.name }}</option>
                            </select>
                            <small *ngIf="submitted && followUpForm.get('stage_id').hasError('required')" class="text-danger">
                                Field is required.
                            </small>
                        </div>

                        <div class="form-group">
                            <label for="reason_id">Reason</label>
                            <select class="form-control" id="reason_id" formControlName="reason_id">
                                <option value="">Select Reason</option>
                                <option [value]="reason?.id" *ngFor="let reason of reasonFollowups">{{ reason?.reasons.name }}</option>
                            </select>
                            <small *ngIf="submitted && followUpForm.get('reason_id').hasError('required')" class="text-danger">
                                Field is required.
                            </small>
                        </div>

                        <div class="form-group">
                            <label for="type">Follow Up</label>
                            <select class="form-control" id="type" formControlName="type">
                                <option value="">Select Type</option>
                                <option value="CALL">Call</option>
                                <option value="WHATS_APP">Whats app</option>
                                <option value="TEXT_MESSAGE">Text Message</option>
                            </select>
                            <small *ngIf="submitted && followUpForm.get('type').hasError('required')" class="text-danger">
                                Field is required.
                            </small>
                        </div>

                        <div class="form-group">
                            <label for="remark">Remarks</label>
                            <input id="remark" class="form-control" type="text" formControlName="remark" placeholder="Example"/>
                        </div>
                    </form>
                </div>

                <div class="ref-fu" *ngIf="modalType === 'VIEW_FOLLOW_UP_REMARKS'">
                    <ng-container *ngIf="allFollowUpItems.length > 0; else noFollowUpToShow">
                        <div class="ref-fu-tools">
                            <div class="ref-seg" role="group" aria-label="Filter by follow-up type">
                                <button type="button" [class.on]="!followUpTypeFilter" (click)="followUpTypeFilter = ''">
                                    All ({{allFollowUpItems.length}})
                                </button>
                                <button type="button" [class.on]="followUpTypeFilter === 'CALL'" (click)="followUpTypeFilter = 'CALL'"
                                        *ngIf="followUpCount('CALL')">
                                    <i class="fas fa-phone-alt mr-1"></i>Call ({{followUpCount('CALL')}})
                                </button>
                                <button type="button" [class.on]="followUpTypeFilter === 'WHATS_APP'" (click)="followUpTypeFilter = 'WHATS_APP'"
                                        *ngIf="followUpCount('WHATS_APP')">
                                    <i class="fab fa-whatsapp mr-1"></i>WhatsApp ({{followUpCount('WHATS_APP')}})
                                </button>
                                <button type="button" [class.on]="followUpTypeFilter === 'TEXT_MESSAGE'" (click)="followUpTypeFilter = 'TEXT_MESSAGE'"
                                        *ngIf="followUpCount('TEXT_MESSAGE')">
                                    <i class="fas fa-comment-dots mr-1"></i>Text ({{followUpCount('TEXT_MESSAGE')}})
                                </button>
                            </div>
                            <button type="button" class="btn btn-outline-secondary btn-sm" (click)="followUpOldestFirst = !followUpOldestFirst">
                                <i class="fas" [ngClass]="followUpOldestFirst ? 'fa-arrow-up' : 'fa-arrow-down'"></i>
                                {{followUpOldestFirst ? 'Oldest first' : 'Newest first'}}
                            </button>
                        </div>

                        <div class="ref-fu-rail">
                            <div class="ref-fu-item" *ngFor="let item of followUpItems">
                                <div class="ref-fu-dot t-{{(item.type || '').toLowerCase()}}">
                                    <i [class]="followUpTypeIcon(item.type)"></i>
                                </div>
                                <div class="ref-fu-card">
                                    <div class="ref-fu-card-h">
                                        <b>{{item.subject || followUpTypeLabel(item.type)}}</b>
                                        <span class="ref-pill t-{{(item.type || '').toLowerCase()}}">{{followUpTypeLabel(item.type)}}</span>
                                    </div>
                                    <div class="ref-fu-meta">
                                        <span>{{item.date_time || 'N/A'}}</span>
                                        <span *ngIf="item.date_time">· {{ago(item.date_time)}}</span>
                                        <span *ngIf="item?.stage?.name"> · Stage: {{item.stage.name}}</span>
                                    </div>
                                    <p class="ref-fu-reason" *ngIf="item?.reason?.name"><i class="fas fa-flag mr-1"></i>{{item.reason.name}}</p>
                                    <p class="ref-fu-remark" *ngIf="item.remark">&ldquo;{{item.remark}}&rdquo;</p>
                                </div>
                            </div>
                            <p class="ref-muted ref-fu-empty" *ngIf="!followUpItems.length">No follow-ups of this type.</p>
                        </div>
                    </ng-container>
                    <ng-template #noFollowUpToShow>
                        <p class="ref-muted ref-fu-empty">No follow-ups recorded yet.</p>
                    </ng-template>
                </div>
            </div>
            <div class="modal-footer">
                <button class="btn btn-outline-secondary" type="button" (click)="this.modalService.dismissAll('')">Close</button>
                <button class="btn btn-success btn-raised" type="button" *ngIf="modalType === 'FOLLOW_UP'" (click)="followUp()"
                        [disabled]="submitting">
                    Submit
                </button>
            </div>
        </div>
    </ng-template>

    <div class="ref-panel">
        <div class="ref-panel-h">
            <div>
                <h2>Referrals</h2>
                <p>Update status and follow up on referrals that came from a CRM lead.</p>
            </div>
            <div class="ref-tools">
                <input class="ref-inp ref-search" type="search" placeholder="Reference or referral code" aria-label="Search by reference or referral code"
                       [(ngModel)]="q" (ngModelChange)="onFilter()">
                <select class="ref-inp" aria-label="Filter by status" [(ngModel)]="status" (ngModelChange)="onFilter()">
                    <option value="">All statuses</option>
                    <option *ngFor="let k of STATUS_KEYS" [value]="k">{{STATUS[k]}}</option>
                </select>
            </div>
        </div>

        <div class="ref-tbl-wrap">
            <table>
                <thead>
                <tr>
                    <th>Reference</th>
                    <th>Referred by</th>
                    <th>Source</th>
                    <th>Created on</th>
                    <th>Status</th>
                    <th>Fraud</th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let r of list">
                    <td><b>{{r.reference}}</b><small>{{r.referred_name}}</small></td>
                    <td>{{r.referrer?.name}}<small>{{r.referrer?.referral_code}}</small></td>
                    <td>{{cap((r.source || '').toLowerCase())}}</td>
                    <td>{{fmt(r.created_at)}}<small>{{ago(r.created_at)}}</small></td>
                    <td>
                        <select *ngIf="isManualStatus(r.status)" class="ref-inp" #sel [attr.aria-label]="'Status for ' + r.reference"
                                [ngModel]="r.status" (ngModelChange)="changeStatus(r, $event, sel)">
                            <option *ngFor="let k of MANUAL_STATUSES" [value]="k">{{STATUS[k]}}</option>
                        </select>
                        <span *ngIf="!isManualStatus(r.status)" class="ref-pill p-{{(r.status || '').toLowerCase()}}">{{STATUS[r.status] || r.status}}</span>
                    </td>
                    <td>
                        <button type="button" class="ref-pill p-{{(r.fraud_status || '').toLowerCase()}} ref-pill-btn"
                                title="Open to review fraud status" (click)="openDetail(r)">{{cap((r.fraud_status || '').toLowerCase())}}</button>
                    </td>
                    <td class="ref-row-acts">
                        <button class="btn btn-outline-secondary btn-sm" type="button" (click)="openDetail(r)">View</button>
                        <button class="btn btn-outline-secondary btn-sm" type="button" (click)="openFollowUp(content, r)">Follow Up</button>
                        <button class="btn btn-outline-secondary btn-sm" type="button" (click)="viewFollowUpRemarks(content, r)">History</button>
                    </td>
                </tr>
                <tr *ngIf="!loading && !list.length">
                    <td colspan="7" class="ref-empty">No referrals match these filters. Clear the search or change the filters.</td>
                </tr>
                <tr *ngIf="loading">
                    <td colspan="7" class="ref-empty">Loading…</td>
                </tr>
                </tbody>
            </table>
        </div>
        <app-ref-pager [total]="total" [page]="page" [per]="per" (pageChange)="onPageChange($event)"></app-ref-pager>
    </div>

    <app-ref-drawer [open]="!!selected" [title]="selected?.reference" (closed)="close()"
                    [sub]="selected ? (selected.referrer?.name + ' · ' + selected.referrer?.referral_code) : ''">
        <ng-container *ngIf="selected">
            <div class="ref-facts">
                <div><span>Referred</span>{{selected.referred_name}}</div>
                <div><span>Source</span>{{cap((selected.source || '').toLowerCase())}}</div>
                <div><span>Status</span>{{STATUS[selected.status] || selected.status}}</div>
                <div><span>Fraud status</span>{{cap((selected.fraud_status || '').toLowerCase())}}</div>
                <div><span>Registered</span>{{selected.registered_at ? fmt(selected.registered_at) : 'Not yet'}}</div>
                <div><span>Converted</span>{{selected.converted_at ? fmt(selected.converted_at) : 'Not yet'}}</div>
                <div *ngIf="selected.closed_at"><span>Closed</span>{{fmt(selected.closed_at)}}</div>
                <div *ngIf="selected.rejection_reason"><span>Rejection reason</span>{{selected.rejection_reason}}</div>
            </div>
            <div>
                <h3>Rewards</h3>
                <p *ngFor="let x of selected.rewards" style="margin-bottom:6px">
                    {{x.event_type}}: {{x.points}} pts <span class="ref-pill p-{{(x.status || '').toLowerCase()}}">{{cap((x.status || '').toLowerCase())}}</span>
                </p>
                <p class="ref-muted" *ngIf="!selected.rewards?.length">No rewards recorded yet.</p>
            </div>
            <div>
                <h3>Fraud flags</h3>
                <div *ngFor="let f of selected.fraud_flags" style="margin-bottom:12px">
                    <p style="margin-bottom:4px">
                        {{cap((f.type || '').toLowerCase().replace('_', ' '))}} · {{cap((f.severity || '').toLowerCase())}}
                        <span class="ref-pill p-{{(f.status || '').toLowerCase()}}">{{cap((f.status || '').toLowerCase())}}</span>
                    </p>
                    <p class="ref-muted" *ngIf="f.reason" style="margin-bottom:6px">{{f.reason}}</p>
                    <p class="ref-muted" *ngIf="!isFraudFlagActive(f) && f.resolution_action" style="margin-bottom:6px">
                        Resolved: {{cap((f.resolution_action || '').toLowerCase().replace('_', ' '))}}{{f.resolution_reason ? ' — ' + f.resolution_reason : ''}}
                    </p>
                    <div *ngIf="isFraudFlagActive(f)" class="ref-row-acts">
                        <button class="btn btn-outline-success btn-sm" type="button" (click)="resolveFlag(selected, f, 'CLEAR')">Clear</button>
                        <button class="btn btn-outline-warning btn-sm" type="button" (click)="resolveFlag(selected, f, 'HOLD_REWARD')">Hold reward</button>
                        <button class="btn btn-outline-danger btn-sm" type="button" (click)="resolveFlag(selected, f, 'BLOCK_REFERRAL')">Block</button>
                        <button class="btn btn-outline-danger btn-sm" type="button" (click)="resolveFlag(selected, f, 'REJECT')">Reject</button>
                    </div>
                </div>
                <p class="ref-muted" *ngIf="!selected.fraud_flags?.length">No fraud flags recorded.</p>
            </div>
        </ng-container>
    </app-ref-drawer>
</section>
